import React, { ReactNode } from 'react';
import BaseComponent from '../base/base-component';

export default class Index extends BaseComponent {
  public render(): ReactNode {
    return <div>Welcome to gatsbys</div>;
  }
}
